import mockMagasin from "@/data/getMagasin.json";
import {getBFF} from "@/function/getUrlProdOrPreprod";
import {Magasin} from "@/ts/interface/magasin";

import {getDataMock} from "./_callApi";
import {callApi} from "./_callApi";

export async function fetchMagasin(
  filtreLabel?: string,
  id?: string,
): Promise<Magasin[] | undefined> {
  if (getDataMock()) {
    const magasins: Magasin[] = mockMagasin;
    return magasins;
  }
  let reponse = undefined;
  if (import.meta.env.VITE_APP_DEV === "true") {
    console.log(filtreLabel, id);
    reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/operation/v1/shops?${filtreLabel ? `${filtreLabel}=${id}` : ""}`,
      "GET",
      {
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
    );
  } else {
    reponse = await callApi(
      `${getBFF()}/operation/v1/shops?${filtreLabel ? `${filtreLabel}=${id}` : ""}`,
      "GET",
      {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      null,
    );
  }
  return reponse;
}
